<template>
    <div>
        <v-text-field label="Título" v-model="ctn.items.title" :disabled="!enabled"></v-text-field>
        <div class="flexsplit">
            <v-text-field label="Texto do Link" v-model="ctn.items.linktitle" :disabled="!enabled"></v-text-field>
            <div class="flexsplit">
                <div class="title-qty">Quantidade:</div>
                <v-radio-group v-model="ctn.items.qty" class="c-radios">
                    <v-radio
                        v-for="n in items"
                        :key="n.value"
                        :label="`${n.label}`"
                        :value="n.value"
                        :disabled="!enabled"
                    ></v-radio>
                </v-radio-group>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [ 'disabled' ],
    data: function() {
        return {
            radioGroup: 4,
            items: [
                { label: '2', value: 2 },
                { label: '4', value: 4 },
                { label: '8', value: 8 },
                { label: 'Todos', value: 300 }
            ],
            ctn: {
                items: {
                    title: '',
                    linktitle: '',
                    qty: 4
                }
            },
            enabled: true
        }
    },
    created: function()
    {
        if( this.$props.disabled === true ) this.enabled = false;
        if(this.$attrs.value) {
            this.ctn.items = this.$attrs.value;
        }
    },
    methods: {
        getModuleData(){
            return this.ctn.items;
        }
    }
}
</script>

<style lang="scss">
// .zindexAdjust
.title-qty {
    padding-top: 25px;
    text-align: right;
}
.c-radios 
{
    .v-input--radio-group__input
    {
        display: block !important;

        .v-radio {
            float: left;
        }
    }
}
</style>

